var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:_vm.alertClass,attrs:{"dense":"","type":_vm.variant,"border":"left","colored-border":""}},[_c('template',{slot:"prepend"},[_c('v-icon',[_vm._v(_vm._s(`mdi-${_vm.icon}`))])],1),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }